import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { IFrameComponent, iframeResizer } from 'iframe-resizer';

@Directive({
	selector: '[snIframeResizer]'
})
export class IframeResizerDirective implements AfterViewInit, OnDestroy {
	component: IFrameComponent;

	constructor(public element: ElementRef) {}

	ngAfterViewInit(): void {
		const components = iframeResizer(
			{
				log: false
			},
			this.element.nativeElement
		);

		/* save component reference so we can close it later */
		this.component = components && components.length > 0 ? components[0] : null;
	}

	ngOnDestroy(): void {
		if (this.component && this.component.iFrameResizer) {
			this.component.iFrameResizer.close();
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/directives/iframe-resizer/iframe-resizer.directive.ts